import React, { useState } from 'react';
import { PageHero } from '../components/PageHero';
import { Section } from '../components/Section';
import { Card } from '../components/Card';
import { Button } from '../components/Button';
import useTheme from '../hooks/useTheme';
import { megaGreenData } from '../data/data';

export const Contact: React.FC = () => {
  const { theme, breakpoint } = useTheme();
  const contact = megaGreenData.contact;
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    service: '',
    message: '',
  });
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // run your existing validation; if errors exist, return
    // if (Object.keys(errors).length) return;

    const serviceTitle =
      megaGreenData.services.services.find((s) => s.id === formData.service)?.title ||
      "Not specified";

    const message = [
      "🌿 *New Website Inquiry — Mega Green*",
      "",
      `*Name:* ${formData.name || "-"}`,
      `*Email:* ${formData.email || "-"}`,
      `*Company:* ${formData.company || "-"}`,
      `*Phone:* ${formData.phone || "-"}`,
      `*Service:* ${serviceTitle}`,
      "",
      "*Message:*",
      formData.message || "-",
    ].join("\n");

    const url = `https://wa.me/${contact.phone}?text=${encodeURIComponent(message)}`;

    // Open WhatsApp in a new tab/window (works for WhatsApp Web + mobile)
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <PageHero
        title="Contact"
        subtitle={contact.pageIntro}
      />

      <Section>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: breakpoint.xs || breakpoint.sm ? '1fr' : '1fr 1fr',
            gap: '48px',
          }}
        >
          <div>
            <Card>
              <h2
                style={{
                  fontSize: breakpoint.xs || breakpoint.sm ? '24px' : '28px',
                  fontWeight: 700,
                  color: theme.text.primary,
                  marginBottom: '24px',
                }}
              >
                Send us a message
              </h2>

              <form onSubmit={handleSubmit}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '20px',
                  }}
                >
                  <div>
                    <label
                      style={{
                        display: 'block',
                        fontSize: '14px',
                        fontWeight: 500,
                        color: theme.text.primary,
                        marginBottom: '8px',
                      }}
                    >
                      Name <span style={{ color: theme.palette.primary.main }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        backgroundColor: theme.background.panel,
                        border: `1px solid ${errors.name ? 'red' : theme.colors.line}`,
                        borderRadius: theme.borderRadius.r1,
                        color: theme.text.primary,
                        fontSize: '16px',
                        fontFamily: 'inherit',
                      }}
                    />
                    {errors.name && (
                      <div style={{ color: 'red', fontSize: '13px', marginTop: '4px' }}>
                        {errors.name}
                      </div>
                    )}
                  </div>

                  <div>
                    <label
                      style={{
                        display: 'block',
                        fontSize: '14px',
                        fontWeight: 500,
                        color: theme.text.primary,
                        marginBottom: '8px',
                      }}
                    >
                      Email <span style={{ color: theme.palette.primary.main }}>*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        backgroundColor: theme.background.panel,
                        border: `1px solid ${errors.email ? 'red' : theme.colors.line}`,
                        borderRadius: theme.borderRadius.r1,
                        color: theme.text.primary,
                        fontSize: '16px',
                        fontFamily: 'inherit',
                      }}
                    />
                    {errors.email && (
                      <div style={{ color: 'red', fontSize: '13px', marginTop: '4px' }}>
                        {errors.email}
                      </div>
                    )}
                  </div>

                  <div>
                    <label
                      style={{
                        display: 'block',
                        fontSize: '14px',
                        fontWeight: 500,
                        color: theme.text.primary,
                        marginBottom: '8px',
                      }}
                    >
                      Company
                    </label>
                    <input
                      type="text"
                      name="company"
                      value={formData.company}
                      onChange={handleInputChange}
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        backgroundColor: theme.background.panel,
                        border: `1px solid ${theme.colors.line}`,
                        borderRadius: theme.borderRadius.r1,
                        color: theme.text.primary,
                        fontSize: '16px',
                        fontFamily: 'inherit',
                      }}
                    />
                  </div>

                  <div>
                    <label
                      style={{
                        display: 'block',
                        fontSize: '14px',
                        fontWeight: 500,
                        color: theme.text.primary,
                        marginBottom: '8px',
                      }}
                    >
                      Phone
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        backgroundColor: theme.background.panel,
                        border: `1px solid ${errors.phone ? 'red' : theme.colors.line}`,
                        borderRadius: theme.borderRadius.r1,
                        color: theme.text.primary,
                        fontSize: '16px',
                        fontFamily: 'inherit',
                      }}
                    />
                    {errors.phone && (
                      <div style={{ color: 'red', fontSize: '13px', marginTop: '4px' }}>
                        {errors.phone}
                      </div>
                    )}
                  </div>

                  <div>
                    <label
                      style={{
                        display: 'block',
                        fontSize: '14px',
                        fontWeight: 500,
                        color: theme.text.primary,
                        marginBottom: '8px',
                      }}
                    >
                      Service
                    </label>
                    <select
                      name="service"
                      value={formData.service}
                      onChange={handleInputChange}
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        backgroundColor: theme.background.panel,
                        border: `1px solid ${theme.colors.line}`,
                        borderRadius: theme.borderRadius.r1,
                        color: theme.text.primary,
                        fontSize: '16px',
                        fontFamily: 'inherit',
                      }}
                    >
                      <option value="">Select a service</option>
                      {megaGreenData.services.services.map((service) => (
                        <option key={service.id} value={service.id}>
                          {service.title}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label
                      style={{
                        display: 'block',
                        fontSize: '14px',
                        fontWeight: 500,
                        color: theme.text.primary,
                        marginBottom: '8px',
                      }}
                    >
                      Message <span style={{ color: theme.palette.primary.main }}>*</span>
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      rows={6}
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        backgroundColor: theme.background.panel,
                        border: `1px solid ${errors.message ? 'red' : theme.colors.line}`,
                        borderRadius: theme.borderRadius.r1,
                        color: theme.text.primary,
                        fontSize: '16px',
                        fontFamily: 'inherit',
                        resize: 'vertical',
                      }}
                    />
                    {errors.message && (
                      <div style={{ color: 'red', fontSize: '13px', marginTop: '4px' }}>
                        {errors.message}
                      </div>
                    )}
                  </div>

                  <Button type="submit" variant="primary" style={{ width: '100%' }}>
                    Send Message
                  </Button>
                </div>
              </form>
            </Card>
          </div>

          <div>
            <Card>
              <h3
                style={{
                  fontSize: '22px',
                  fontWeight: 600,
                  color: theme.text.primary,
                  marginBottom: '16px',
                }}
              >
                Contact Information
              </h3>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                }}
              >
                <div>
                  <div
                    style={{
                      fontSize: '12px',
                      fontWeight: 600,
                      color: theme.text.muted,
                      marginBottom: '4px',
                    }}
                  >
                    Email
                  </div>
                  <a
                    href={`mailto:${contact.email}`}
                    style={{
                      color: theme.palette.primary.main,
                      textDecoration: 'none',
                      fontSize: '16px',
                    }}
                  >
                    {contact.email}
                  </a>
                </div>
                <div>
                  <div
                    style={{
                      fontSize: '12px',
                      fontWeight: 600,
                      color: theme.text.muted,
                      marginBottom: '4px',
                    }}
                  >
                    Phone
                  </div>
                  <a
                    href={`tel:${contact.phone}`}
                    style={{
                      color: theme.text.primary,
                      textDecoration: 'none',
                      fontSize: '16px',
                    }}
                  >
                    {contact.phone}
                  </a>
                </div>
                <div>
                  <div
                    style={{
                      fontSize: '12px',
                      fontWeight: 600,
                      color: theme.text.muted,
                      marginBottom: '4px',
                    }}
                  >
                    Address
                  </div>
                  <div
                    style={{
                      color: theme.text.primary,
                      fontSize: '16px',
                    }}
                  >
                    {contact.address}
                  </div>
                </div>
              </div>
              <p
                style={{
                  fontSize: '12px',
                  color: theme.text.muted,
                  marginTop: '16px',
                  fontStyle: 'italic',
                }}
              >
                {contact.responseTimePromise}
              </p>
            </Card>

            {/* <Card style={{ marginTop: '24px' }}>
              <PlaceholderImage label="MAP PLACEHOLDER" height={300} />
            </Card> */}
          </div>
        </div>
      </Section>
    </>
  );
};

